import { useActiveLocale } from "i18n/activeLocale";
import { SupportedLocale } from "types/i18n/SupportedLocaleEnum";

import { cn } from "../../../../products/muggleTestV0/lib/utils";

interface EnglishOnlyNoticeProps {
  /** Translated notice text, e.g. "This page is available in English only." in the active locale. */
  message: string;
  className?: string;
}

/**
 * One-line notice above content that is published in English only; renders nothing in English.
 *
 * @param message - The notice text in the active locale.
 * @param className - Extra layout classes for the notice line.
 */
export function EnglishOnlyNotice({ message, className }: EnglishOnlyNoticeProps) {
  const activeLocale = useActiveLocale();

  if (activeLocale === SupportedLocale.English) {
    return null;
  }

  return (
    <p role="note" className={cn("text-sm text-muted-foreground", className)}>
      {message}
    </p>
  );
}
